var _circle, _path, _path2, _path3, _path4, _ellipse, _path5, _path6, _circle2, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgHauntedFlashlightGray = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "#D5D8DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.4499 30.9079L75.1752 16.1499C75.1752 16.1499 84.9003 25.977 84.5252 43.1634C84.15 60.3499 74 70.4999 74 70.4999L51.4499 55.9999C51.4499 55.9999 47.6 51.2162 47.6 43.1634C47.6 35.1107 51.4499 30.9079 51.4499 30.9079Z",
    fill: "#F1F2F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.40002 43.4832C3.40002 40.1372 5.78748 37.2677 9.07762 36.6591L14.5006 35.656V51.2481L9.15414 50.321C5.82848 49.7443 3.40002 46.8585 3.40002 43.4832Z",
    fill: "#505862"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5004 35.656H41.0648V51.2481H14.5004C14.5004 51.2481 11.8696 50.5102 11.8696 43.4521C11.8696 36.3939 14.5004 35.656 14.5004 35.656Z",
    fill: "#9DA4AF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9827 43.4523C61.9827 52.1522 57.8485 59.2048 52.7487 59.2048C52.0868 59.2048 51.4413 59.086 50.8189 58.8603L45.6527 56.3174L38.3126 52.5913C36.8482 51.8479 35.631 50.669 35.2075 49.0822C34.8517 47.7488 34.52 45.8787 34.52 43.5397C34.52 41.1585 34.8637 39.2632 35.2268 37.9255C35.6448 36.3853 36.8166 35.2314 38.2273 34.4851L46.2623 30.2342L50.8189 28.0442C51.4413 27.8185 52.0868 27.6997 52.7487 27.6997C57.8485 27.6997 61.9827 34.7524 61.9827 43.4523Z",
    fill: "#505862"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.6413,
    cy: 43.2597,
    rx: 6.54485,
    ry: 13.5709,
    fill: "#D5D8DD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4601 41.1422C45.4601 34.9502 48.1978 31.1217 48.8609 30.1699C45.2676 32.2874 38.6394 35.0786 37.1507 36.3619C35.6621 37.6452 35.6749 40.0834 35.5145 41.7838L45.4601 41.1422Z",
    fill: "#9DA4AF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1402 36.8657C14.203 36.716 14.3494 36.6187 14.5117 36.6187H33.9667C34.2401 36.6187 34.4341 36.8851 34.3502 37.1452L33.9684 38.3286C33.9147 38.495 33.7599 38.6078 33.585 38.6078H14.0155C13.7276 38.6078 13.5326 38.3146 13.6439 38.0491L14.1402 36.8657Z",
    fill: "#505862"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.4297,
    cy: 37.7413,
    r: 1.76454,
    fill: "#22262A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8973 47.9892C47.9229 48.2102 48.1233 48.3704 48.3414 48.3266C49.3868 48.1165 50.3378 47.5658 51.0417 46.7549C51.834 45.8423 52.2559 44.6661 52.2245 43.4579C52.1931 42.2497 51.7106 41.097 50.872 40.2267C50.1269 39.4535 49.1486 38.9529 48.0937 38.7975C47.8736 38.7651 47.6818 38.9354 47.6678 39.1575L47.4337 42.8659C47.4036 43.3434 47.416 43.8227 47.4709 44.298L47.8973 47.9892Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHauntedFlashlightGray);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/HauntedFlashlightGray.0d10236a975d2763fdd1bcf2ad325863.svg";